export type CheckoutRoute = 'shipping' | 'create-account'

export const getRouteFromPath = (pathname: string): CheckoutRoute | null => {
    if (pathname.endsWith('/checkout/shipping')) return 'shipping'
    if (pathname.endsWith('/checkout/create-account')) return 'create-account'
    return null
}
